import { useContext, useEffect, useState } from "react";
import { SidebarContext } from "context/SidebarContext";

const useToggleDrawer = () => {
  const [isViewMode, setIsViewMode] = useState(false);
  const [serviceId, setServiceId] = useState("");
  const [start_date, setStartDate] = useState("");
  const [end_date, setEndDate] = useState("");
  const [days, setDays] = useState("");
  const [percentage, setPercentage] = useState("");
  const [vendor_name, setVendorName] = useState("");
  const [vendor_id, setVendorId] = useState("");
  const [allId, setAllId] = useState([]);
  const [title, setTitle] = useState("");
  const [serviceBlock, setServiceBlock] = useState("");
  const [, setServiceActive] = useState("");
  const [billAmount, setBillAmount] = useState(""); // New state for billAmount
  const [vaId, setVaId] = useState(""); // New state for vaId

  const {
    toggleDrawer,
    isDrawerOpen,
    toggleModal,
    toggleModalBlock,
    toggleModalView,
    toggleBulkDrawer,
    isModalOpen,
    isViewModalOpen
  } = useContext(SidebarContext);

  const handleUpdate = (id, days, percentage) => {
    setServiceId(id);
    toggleDrawer();
    setDays(days);
    setPercentage(percentage);
  };

  const handleVendorUpdate = (id, start_date, end_date) => {
    setServiceId(id);
    setStartDate(start_date);
    setEndDate(end_date);
    toggleDrawer();
  };
  const handleModifyUpdate = (
    id,
    start_date,
    end_date,
    vendor_name,
    vendor_id,
    days_count
  ) => {
    setServiceId(id);
    setStartDate(start_date);
    setVendorName(vendor_name);
    setDays(days_count);
    setVendorId(vendor_id);
    setEndDate(end_date);
    toggleDrawer();
  };

  // New handler to pass billAmount and vaId
  const handleAddOrModify = (id, bill_amount, va_id) => {
    setServiceId(id);
    setBillAmount(bill_amount);
    setVaId(va_id);
    toggleDrawer();
  };

  const handleUpdateMany = (id) => {
    setAllId(id);
    toggleBulkDrawer();
  };

  const handleModalOpen = (id, title) => {
    setServiceId(id);
    toggleModal();
    setTitle(title);
  };
  const handleView = (id, title) => {
    setServiceId(id);
    toggleModalView();
    setTitle(title);
  };
  const handleJobDetails = (id, title) => {
    setServiceId(id);
    toggleModalView();
    setTitle(title);
  };
  const handleMenuDetails = (id_menu, title) => {
    setServiceId(id_menu);
    toggleModalView();
    setTitle(title);
  };

  const handleViewOrder = (id, title) => {
    setServiceId(id);
    toggleModalView();
    setTitle(title);
  };

  const handleBlock = (id, block, title) => {
    setServiceId(id);
    setServiceBlock(block);
    toggleModalBlock();
    setTitle(title);
  };
  const handleActive = (id, active, title) => {
    setServiceId(id);
    setServiceActive(active);
    toggleModalBlock();
    setTitle(title);
  };
  const handleMenu = (id, active, title) => {
    setServiceId(id);
    setServiceActive(active);
    toggleModalBlock();
    setTitle(title);
  };
  const handleContact = (id, active, title) => {
    setServiceId(id);
    setServiceActive(active);
    toggleModalBlock();
    setTitle(title);
  };
  useEffect(() => {
    if (!isDrawerOpen) {
      setIsViewMode(false);
    }
    if (!isDrawerOpen && !isModalOpen) {
      setServiceId("");
    }
  }, [isDrawerOpen, isModalOpen]);

  useEffect(()=>{
    if(!isViewModalOpen){
      setServiceId("");
    }
  },[isViewModalOpen])

  const handleDeleteMany = async (id, products) => {
    setAllId(id);
    toggleModal();
    setTitle("Selected Products");
  };
  return {
    title,
    allId,
    serviceId,
    start_date,
    end_date,
    days,
    percentage,
    setPercentage,
    setDays,
    vendor_name,
    vendor_id,
    billAmount, // Expose billAmount state
    vaId, // Expose vaId state
    setVendorName,
    setVendorId,
    serviceBlock,
    handleUpdate,
    setServiceId,
    setServiceBlock,
    setServiceActive,
    handleModalOpen,
    handleDeleteMany,
    handleUpdateMany,
    handleVendorUpdate,
    handleModifyUpdate,
    handleAddOrModify, // Expose new handler
    setStartDate,
    setEndDate,
    handleView,
    handleJobDetails,
    handleMenuDetails,
    handleViewOrder,
    handleBlock,
    handleActive,
    handleMenu,
    handleContact,
    setIsViewMode,
    isViewMode,
    // updateServiceId,
  };
};

export default useToggleDrawer;
